import React from 'react';

import { ExactMatchSwitch } from '../ExactMatchSwitch';
import { SortByDropdown, type SortOption } from '../SortByDropdown';

import {
  FiltersContainer,
  DropdownsContainer,
  VerticalDivider,
} from './components';

export interface SearchFiltersBarProps {
  sortValue: string;
  sortOptions: SortOption[];
  onSortChange: (value: string) => void;
  exactMatch: boolean;
  onExactMatchChange: (checked: boolean) => void;
  showExactMatch?: boolean;
  sortLabel?: string;
}

export const SearchFiltersBar: React.FC<SearchFiltersBarProps> = ({
  sortValue,
  sortOptions,
  onSortChange,
  exactMatch,
  onExactMatchChange,
  showExactMatch = true,
  sortLabel = 'Sort By',
}) => {
  return (
    <FiltersContainer>
      <DropdownsContainer>
        <SortByDropdown
          value={sortValue}
          options={sortOptions}
          onChange={onSortChange}
          label={sortLabel}
        />
      </DropdownsContainer>

      {showExactMatch && (
        <>
          <VerticalDivider orientation="vertical" flexItem />
          <ExactMatchSwitch
            checked={exactMatch}
            onChange={onExactMatchChange}
          />
        </>
      )}
    </FiltersContainer>
  );
};
